module.exports = __webpack_public_path__ + "assets/media/day38.4b224510.mp3";